_BannerFlowApp.directive("objectPicker", function (AuthInfo, $rootScope, Feed, $controller) {
    return {
        restrict: "E",
        templateUrl: "/legacy-app/js/directives/templates/object-picker.html",
        replace: true,
        scope: {
            brand: "=?",
            notNull: "=?",
            ignoreIsDone: "=?",
            placeholder: "@?",
            type: "=?",
            buttonText: "@?",
            folder: "=?",
            showFolders: "=?",
            hidePickerPanel: "=?",
            itemName: "@?"
        },
        require: "?ngModel",
        controller: function ($scope, $attrs) {
            $scope.model = {
                buttonText: $scope.buttonText || "Select...",
                showFolders: $scope.showFolders,
                hidePickerPanel: $scope.hidePickerPanel,
                type: $scope.type || $rootScope.OBJECT_TYPE_FEED,
                itemName: $scope.itemName || "item",
                browserOpen: false,
                loading: false,
                objects: null,
                object: null,
                query: "",
                selectedIndex: -1,
                notNull: $scope.notNull ? true : false,
                ignoreIsDone: $scope.ignoreIsDone ? true : false,
                placeholder: $scope.placeholder,
                guid: makeGUID()
            };

            if ($scope.showFolders) {
                $scope.urlParams = {
                    foldersOnly: true,
                    folderId: $scope.folder,
                    preventUrlUpdate: true,
                    customBrand: true
                };

                $controller("ListController", { $scope: $scope });

                if ($scope.model.type === $rootScope.OBJECT_TYPE_FEED) {
                    $scope.listModel.resource = Feed;
                }

                $scope.gotoRoot = function () {
                    $scope.urlParams.folderId = null;
                    $scope.folder = null;
                    $scope.reloadTable();
                };

                $scope.gotoFolder = function (folder) {
                    $scope.urlParams.folderId = folder;
                    $scope.folder = folder;

                    $scope.reloadTable();
                };
            }

            $scope.selectObject = function (object) {
                $scope.model.object = object;

                if ($scope.showFolders) {
                    //Instruct ListController to fetch folders from specified brand
                    $scope.listModel.customBrand = $scope.model.object.id;
                    $scope.urlParams.folderId = null;

                    $scope.reloadTable();
                }

                $scope.model.browserOpen = false;
            };
        },
        link: function (scope, element, attrs, modelCtrl) {
            scope.keyup = function (e) {
                var key = null;
                if (window.event) {
                    key = e.keyCode;
                } // IE
                else if (e.which) {
                    key = e.which;
                }
                var up = false;

                if (key === 40) {
                    scope.model.selectedIndex += 1;
                    if (scope.model.selectedIndex > scope.model.objects.length - 1)
                        scope.model.selectedIndex = scope.model.objects.length - 1;
                } else if (key === 38) {
                    up = true;
                    scope.model.selectedIndex -= 1;
                    if (scope.model.selectedIndex < -1) scope.model.selectedIndex = -1;
                } else if (key === 13) {
                    scope.selectObject(scope.model.objects[scope.model.selectedIndex]);
                }

                var elem = $(".objects-list .object.selected").first();

                var offset = up ? 0 : elem.height() * 2;

                if (elem) {
                    $(".objects-list", element).scrollTop(
                        $(".objects-list", element).scrollTop() +
                            elem.position().top -
                            ($(".objects-list", element).height() - offset)
                    );
                }
            };

            // Update element when model changes
            scope.$watch(
                function () {
                    modelCtrl.$setViewValue(scope.model.object);

                    return modelCtrl.$modelValue;
                },
                function (newVal, oldVal) {
                    //scope.checked = modelCtrl.$modelValue === trueValue;
                },
                true
            );

            scope.search = function () {
                var brands = angular.copy(AuthInfo.LoggedInUser.currentAccount.brands);
                scope.selectedIndex = -1;
                scope.model.objects = scope.model.query
                    ? _.filter(brands, function (b) {
                          return b.name.toLowerCase().indexOf(scope.model.query.toLowerCase()) != -1;
                      })
                    : brands;
                scope.model.loading = false;
            };

            scope.$watch("model.query", function (n, o) {
                if (n === o) return;

                scope.search();
            });

            scope.$watch("model.browserOpen", function (n, o) {
                if (n === o) return;

                if (n) {
                    scope.model.selectedIndex = -1;
                    scope.model.query = "";
                    scope.search();

                    $("#object-picker-search-input").focus();
                }
            });

            modelCtrl.$render = function () {
                scope.model.object = modelCtrl.$viewValue;

                if (scope.listModel)
                    scope.listModel.customBrand = scope.model.object ? scope.model.object.id : null;
            };

            scope.toggleBrowser = function () {
                if (!scope.model.browserOpen) {
                    scope.openBrowser();
                } else {
                    scope.closeBrowser();
                }
            };

            scope.openBrowser = function () {
                $(window).on("mousedown", function (e) {
                    if (
                        !$(e.target).is("#op-" + scope.model.guid) &&
                        !$(e.target)
                            .parents("#op-" + scope.model.guid)
                            .size()
                    ) {
                        $(window).off("mousedown");
                        scope.$apply(function () {
                            scope.closeBrowser();
                        });
                    }
                });

                scope.model.browserOpen = true;
            };

            scope.closeBrowser = function () {
                scope.model.browserOpen = false;
                $(window).off("mousedown");
            };
        }
    };
});
